import environment from '@/environments/environment.dev'

import HttpClient from '../apiHttpClient'

const RENTAL_ENDPOINT = '/v1.0/rental'

const adminFapiClient = new HttpClient(environment.adminFAPIUrl)

interface PaginationParameters {
  pageNumber: number
  pageSize: number
  sortBy: string
  orderBy: string
}

interface DeleteProductParameters {
  materialNumber: string
  countryId: string
}

interface SuggestionParameters {
  query: string
  cancelToken?: unknown // Adjust type if your `HttpClient` expects something specific
}

const createSearchParameters = (
  parameters: Record<string, string | number>,
): string => {
  const searchParameters = new URLSearchParams()
  for (const [key, value] of Object.entries(parameters)) {
    searchParameters.append(key, value.toString())
  }
  return searchParameters.toString()
}

const getRentableProductList = async ({
  pageNumber,
  pageSize,
  sortBy,
  orderBy,
}: PaginationParameters) => {
  const queryString = createSearchParameters({
    pageNumber,
    pageSize,
    sortType: sortBy,
    sortOrder: orderBy,
  })
  return adminFapiClient.get(`${RENTAL_ENDPOINT}/list?${queryString}`)
}

const deleteProductFromRentableList = async ({
  materialNumber,
  countryId,
}: DeleteProductParameters) => {
  const queryString = createSearchParameters({ materialNumber, countryId })
  return adminFapiClient.delete(`${RENTAL_ENDPOINT}/delete?${queryString}`, {
    body: null,
  })
}

const getSuggestionsProductsList = async ({
  query,
  cancelToken,
}: SuggestionParameters) => {
  const queryString = createSearchParameters({ query })
  return adminFapiClient.get(
    `${RENTAL_ENDPOINT}/search?${queryString}`,
    cancelToken,
  )
}

const addRental = async (data: Record<string, unknown>) => {
  return adminFapiClient.post(`${RENTAL_ENDPOINT}/add`, {
    body: data,
  })
}

export const adminFapiRental = {
  getRentableProductList,
  deleteProductFromRentableList,
  getSuggestionsProductsList,
  addRental,
}
